import {WriteIconButton} from '../common/buttons/WriteActions';
import React, {useRef} from "react";
import {Autocomplete, Box, TextField} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RestoreIcon from '@mui/icons-material/Restore';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {subOrderSelectorActionSx, subOrderSelectorSx} from './subOrderStyles';

interface DecorationSelectorProps {
    options: string[];
    id: string;
    name?: string;
    quantity: number;
    onChangeName: (id: string, decorationName: string) => void;
    onChangeCount: (id: string, quantity: number) => void;
    onRemove: (id: string) => void;
    onRestore?: (id: string) => void;
    isDeleted?: boolean;
}

export const DecorationSelector: React.FC<DecorationSelectorProps> = ({
                                                                          options,
                                                                          id,
                                                                          name,
                                                                          quantity,
                                                                          onChangeName,
                                                                          onChangeCount,
                                                                          onRemove,
                                                                          onRestore,
                                                                          isDeleted = false,
                                                                      }) => {
    const {t} = useAppTranslation();
    const inputCountRef = useRef<HTMLInputElement>(null);
    const borderColor = name ? 'green' : 'warning.main';
    const borderColorQty = quantity > 0 ? 'green' : 'warning.main';

    return (<Box sx={{
        ...subOrderSelectorSx,
        opacity: isDeleted ? 0.7 : 1,
        textDecoration: isDeleted ? 'line-through' : 'none',
        backgroundColor: isDeleted ? 'rgba(211,47,47,0.10)' : 'transparent',
        borderRadius: isDeleted ? 1 : 0,
    }}>
        <Autocomplete
            disablePortal
            id={`decoration_${id}`}
            options={options}
            value={name || null}
            disabled={isDeleted}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={t('orders:decoration')}
                    placeholder={t('orders:select_decoration')}
                    error={!isDeleted && !name}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        ...params.InputProps,

                        // endAdornment: (
                        //     <>
                        //         {/*{!newSubOrder.recipeName && (
                        //             <InputAdornment position="end">
                        //                 <Tooltip
                        //                     title="Выберите рецепт"
                        //                     arrow
                        //                 >
                        //                     <ErrorOutlineRoundedIcon
                        //                         color="error"
                        //                         fontSize="small"
                        //                         style={{
                        //                             cursor: 'pointer',
                        //                             opacity: 0.7,
                        //                             marginRight: 4,
                        //                         }}
                        //                     />
                        //                 </Tooltip>
                        //             </InputAdornment>
                        //         )}*/}
                        //
                        //         {params.InputProps.endAdornment}
                        //     </>
                        // ),
                    }}
                />
            )}
            noOptionsText={t('orders:no_decorations')}
            clearOnEscape
            onChange={(_, newValue) => onChangeName(id, newValue ?? '')}
            sx={{
                gridArea: 'name',
                width: '100%',
                minWidth: 0,
                '&.MuiAutocomplete-root .MuiInputLabel-root': {},
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {borderWidth: '2px', borderColor},
                    '&:hover fieldset': {borderColor},
                    '&.Mui-focused fieldset': {borderColor},
                },
            }}
        />
        <TextField
            sx={{
                gridArea: 'quantity',
                width: '100%',
                minWidth: 0,
                '& .MuiOutlinedInput-notchedOutline': {
                    borderWidth: '2px',
                    borderColor: borderColorQty,
                },
            }}
            inputRef={inputCountRef}
            id={`decoration_quantity_${id}`}
            label={t('orders:decoration_quantity')}
            placeholder={t('orders:decoration_quantity')}
            value={quantity}
            disabled={isDeleted}
            error={!isDeleted && quantity <= 0}
            type="number"
            inputProps={{
                min: 1,
            }}
            onChange={(e) => onChangeCount(id, Number(e.target.value))}
            onFocus={() => inputCountRef.current && inputCountRef.current.select()}
        />

        <WriteIconButton
            aria-label={t(isDeleted ? 'common:restore' : 'common:delete')}
            color={isDeleted ? 'success' : 'error'}
            onClick={() => isDeleted && onRestore ? onRestore(id) : onRemove(id)}
            size="small"
            sx={subOrderSelectorActionSx}
        >
            {isDeleted ? <RestoreIcon/> : <DeleteOutlineIcon/>}
        </WriteIconButton>
    </Box>)
}
